export default __webpack_public_path__ + "static/media/BedActive.733c867b.svg";